import EntityBaseRepository from '@/api/misc/EntityBaseRepository';
import Tracking from '@/models/Tracking';
import store from '@/store';

export default class TrackingRepository extends EntityBaseRepository {

    public sendTrackingData(trackingData: Tracking | Partial<Tracking>): boolean {

        // if the data comes directly from vuex localstorage, the class information are lost
        if (!(trackingData instanceof Tracking)) {
            trackingData = Object.assign(new Tracking(), trackingData);
        }

        const urlEncoded = new URLSearchParams();
        urlEncoded.append('f', 'magazineReadAddToHotspot');
        // Unfortunately does the .sendBeacon method not support custom headers ...
        // Therefore we need to pass the bridge value in post body...
        if (store.getters['auth/bridge']) {
            urlEncoded.append('bridge', store.getters['auth/bridge']);
        }
        urlEncoded.append('json', JSON.stringify(trackingData.apiRepresentation));
        // ATTENTION!
        // No axios is used here.
        // Instead this is used: https://developer.mozilla.org/en-US/docs/Web/API/Navigator/sendBeacon.
        // This is a special method to send a reliable request just before a site is removed. Like when the browser
        // is closed. Normal xhr requests are aborted in such a case.
        // The blob is needed to set the content type explicitly, otherwise chrome uses text/plain
        // and this content type is not allowed for shm backend.
        const blob = new Blob([urlEncoded.toString()], { type: 'application/x-www-form-urlencoded' });
        return navigator.sendBeacon(this.baseURL + this.endpointDefault, blob);
    }
}
